import React from 'react'
import { Table, Modal, Avatar, Typography, Tag, Tooltip, Icon, Button, message, notification, Form, Input } from 'antd'
import { TableRowEditButton } from '../../components/AppButton'
import defaultPicture from '../../assets/default.png'
import { exportForceMTS, generateJWT } from '../../api/seller'

const { Paragraph, Text } = Typography

class ItemListTable extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleDeleteButtonOnClick = this.handleDeleteButtonOnClick.bind(this)

    this.state = {
      activeSeller: 0,
      loadingForce: false,
      visibleModal: false,
      authDataJWTGenerate: {
        login: '',
        password: '',
      },
    }
  }

  handleDeleteButtonOnClick() {
    const handleTableOnDelete = () => { this.props.onDelete() }
    Modal.confirm({
      title: 'Удалить запись',
      content: 'Вы действительно хотите удалить запись?',
      onOk() {
        handleTableOnDelete()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }

  forceMTSExport(e) {
    this.setState({ loadingForce: true })

    const values = {
      id: e.idnum,
    }

    exportForceMTS(values).then(() => {
      notification.success({
        message: 'Информация',
        description:
          'Очередь на выгрузку успешно добавлена!',
      })

      this.setState({ loadingForce: false })
    })
      .catch(() => {
        message.error('Ошибка выполнения!')
        this.setState({ loadingForce: false })
      })
  }

  forceJWTGenerate(sellerID, userData) {
    this.setState({ loadingForce: true })

    const values = {
      id: sellerID,
    }

    generateJWT(values, userData).then(() => {
      notification.success({
        message: 'Информация',
        description:
          'Очередь на создание JWT успешно создана!',
      })

      this.setState({ loadingForce: false })
      this.changeVisibleModal(false)
    })
      .catch(() => {
        message.error('Ошибка выполнения!')
        this.setState({ loadingForce: false })
        this.setState({ activeSeller: sellerID })
        this.changeVisibleModal(true)
      })
  }

  changeVisibleModal(visible) {
    this.setState({ visibleModal: visible })
  }

  render() {
    const {
      loadingForce, visibleModal, activeSeller, authDataJWTGenerate,
    } = this.state

    const columns = [
      {
        title: 'ID',
        dataIndex: 'idnum',
        key: 'idnum',
        width: '7%',
        sorter: true,
      }, {
        title: 'Блокировка',
        dataIndex: 'n_disable',
        key: 'n_disable',
        width: '7%',
        render: (record, row) => (!row.is_itog ?
          (record ? (
            <Tag color='red'>Включена</Tag>
          ) : (
            <Tag color='green'>Выключена</Tag>
          )) : ''),
      }, {
        title: 'Лого',
        dataIndex: 's_logo',
        key: 's_logo',
        width: '5%',
        render: (record, row) => (!row.is_itog ? <Avatar src={record || defaultPicture} /> : ''),
      }, {
        title: 'Название',
        dataIndex: 's_name',
        key: 's_name',
        width: '15%',
        sorter: true,
        render:
          (record, row) => (!row.is_itog ? (<div>
            {
              row.n_mts_exchange_minutes > 0 &&
              <Tooltip title='Принудительная выгрузка МТС'>
                <Button style={{ marginRight: 2 }} loading={loadingForce} type='link' size='small' onClick={() => this.forceMTSExport(row)}>
                  <Icon type='cloud-upload' />
                </Button>
              </Tooltip>
            }
            <Text copyable={{ text: row.s_url_report }} href={row.s_url_report}>
              <a href={row.s_url_report} target='_blank'>{record} {row.s_inn ? `(${row.s_inn})` : ''}</a>
            </Text>
                                            </div>) : ''),
      }, {
        title: 'Баланс',
        dataIndex: 'n_balance',
        key: 'n_balance',
        width: '10%',
        sorter: true,
        render: (record, row) => (!row.is_itog ? parseFloat(record).toFixed(2) : ''),
      }, {
        title: 'Клиентов',
        dataIndex: 'customers',
        key: 'customers',
        width: '10%',
        sorter: true,
        render: (record, row) => (!row.is_itog ? parseInt(record) : ''),
      }, {
        title: () =>
          (<React.Fragment>
            Касс <Tooltip title='Количество активных касс за последний месяц'>
              <Icon type='question-circle' style={{ fontSize: 12, color: '#3e3e3e' }} />
                 </Tooltip>
           </React.Fragment>),
        dataIndex: 'kassa',
        key: 'kassa',
        width: '8%',
        sorter: true,
        render: record => parseInt(record),
      }, {
        title: () =>
          (<React.Fragment>
            Заведений <Tooltip title='Всего заведений/заведений ЕПО'>
              <Icon type='question-circle' style={{ fontSize: 12, color: '#3e3e3e' }} />
            </Tooltip>
           </React.Fragment>),
        dataIndex: 'points',
        key: 'points',
        width: '10%',
        sorter: true,
        render: (record, row) => (
          row.idnum !== 'Итого'
            ?
              <Tooltip title='Запрос на генерацию JWT'>
                {`${parseInt(record)}/${parseInt(row.epo)}`}
                <Button style={{ marginRight: 2 }} loading={loadingForce} type='link' size='small' onClick={() => this.forceJWTGenerate(row.idnum, {})}>
                  <Icon type='api' />
                </Button>
              </Tooltip>
            :
            parseInt(row.epo) >= 1 ? `${parseInt(record)}/${parseInt(row.epo)}` : `${parseInt(record)}`),
      }, {
        title: 'Чеков',
        dataIndex: 'checks',
        key: 'checks',
        width: '9%',
        sorter: true,
        render: record => parseInt(record),
      }, {
        title: 'Чеков за 24 часа',
        dataIndex: 'checks_last_day',
        key: 'checks_last_day',
        width: '9%',
        sorter: true,
        render: record => parseInt(record),
      }, {
      //   title: 'Активная рассылка',
      //   dataIndex: 'mailing',
      //   key: 'mailing',
      //   render: record => <Progress percent={parseInt(record)} status={parseInt(record) === 100 ? "success" : "active"} />
      // },{
        title: 'Действие',
        key: 'action',
        width: '10%',
        onHeaderCell: () => ({
          style: {
            whiteSpace: 'nowrap',
          },
        }),
        onCell: () => ({
          style: {
            whiteSpace: 'nowrap',
          },
        }),
        render: (record, row) => (!row.is_itog ? (
          <span>
            <TableRowEditButton to={`${this.props.editPath}/${record.idnum}`} />
            <br />
            <TableRowEditButton to={`${this.props.editPath}/${record.idnum}?points`} name='Заведения' />
          </span>
        ) : ''),
      },
    ]

    return (
      <React.Fragment>
        <Table
          className='main-table'
          rowKey={record => `item-row-${record.idnum}`}
          columns={columns}
          footer={() => !!this.props.dataSource.points &&
            <Table
              className='footer-table'
              showHeader={false}
              rowKey={record => `item-row-${record.idnum}`}
              columns={columns}
              dataSource={[{
                idnum: 'Итого',
                // n_balance: this.props.dataResult.n_balance,
                kassa: this.props.dataSource.kassa,
                points: this.props.dataSource.points,
                epo: this.props.dataSource.epo,
                checks: this.props.dataSource.checks,
                checks_last_day: this.props.dataSource.checks_last_day,
                is_itog: true,
              }]}
              size='middle'
              pagination={false}
            />
          }
          {...this.props}
        />
        <Modal
          title='Введите учетные данные'
          viewMode={3}
          visible={visibleModal}
          okText='Применить'
          onOk={() => this.forceJWTGenerate(activeSeller, authDataJWTGenerate)}
          cancelText='Отменить'
          onCancel={() => this.changeVisibleModal(false)}
        >
          <Form.Item>
            <Input
              placeholder='Логин'
              defaultValue={authDataJWTGenerate.login}
              onChange={e => authDataJWTGenerate.login = e.target.value}
            />
          </Form.Item>
          <Form.Item>
            <Input
              type='password'
              placeholder='Пароль'
              defaultValue={authDataJWTGenerate.password}
              onChange={e => authDataJWTGenerate.password = e.target.value}
            />
          </Form.Item>
        </Modal>
      </React.Fragment>
    )
  }
}

export default ItemListTable



// WEBPACK FOOTER //
// src/containers/SellerList/Table.jsx